export default __webpack_public_path__ + "static/media/KI.884648a8.svg";